import * as React from 'react';
import { connect } from 'react-redux';
import './GraphCallout.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faGrinHearts,
	faSmileBeam,
	faMeh,
	faFrown,
	faSadCry,
} from '@fortawesome/free-regular-svg-icons';
import AppCallout from '../AppCallout/AppCallout';
import { DirectionalHint } from '@fluentui/react';
import { ThemeMO } from '../../models/ThemeMO';

export interface AppProps {
	themeMO: ThemeMO;
}

export interface AppState {
	isCalloutVisible: boolean;
}

class GraphCallout extends React.Component<AppProps, AppState> {
	constructor(props, context) {
		super(props, context);

		this.state = { isCalloutVisible: false };
	}
	componentDidMount() {
		//
	}
	componentWillUnmount() {
		//
	}
	private showDiagnosisCallout = () => {
		this.setState({ isCalloutVisible: !this.state.isCalloutVisible });
	};
	renderCallout = () => {
		const onCalloutDismiss = () => {
			this.setState({ isCalloutVisible: false });
		};
		let { themeMO } = this.props;
		let icons = [faSmileBeam, faGrinHearts, faMeh, faFrown, faSadCry];
		return (
			<AppCallout
				key={'_callout_emojis'}
				target={'.graph-part-emojis-callout'}
				directionalHint={DirectionalHint.bottomCenter}
				onDismiss={() => {
					onCalloutDismiss();
				}}
				onClick={() => {
					onCalloutDismiss();
				}}>
				<h3 className="theme-title">Theme: {themeMO.themeTitle}</h3>
				<table>
					{icons.map((icon, i) => (
						<tr key={i}>
							<td>
								<FontAwesomeIcon icon={icon} /> {'   '}
							</td>
							<td>
								{themeMO.key !== 'sunny-weather' ? (
									themeMO.ratings[i]
								) : (
									<span className="emoji-font">{themeMO.ratings[i]}</span>
								)}
							</td>
						</tr>
					))}
				</table>
			</AppCallout>
		);
	};

	render() {
		return (
			<div
				className={'graph-part-emojis-callout'}
				onClick={this.showDiagnosisCallout}>
				{this.state.isCalloutVisible ? this.renderCallout() : ''}
			</div>
		);
	}
}

const mapStateToProps = ({ themeMO }) => ({
	themeMO,
});

export default connect(mapStateToProps, null)(GraphCallout);
